import usePermissions from "hooks/usePermissions";
import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";

interface PortCountryProps {
  isPickupOrDelivery: string;
}

export default function PortCountry({ isPickupOrDelivery }: PortCountryProps) {
  const intl = useIntl();
  const { permissions }: any = usePermissions();
  const { enable_new_address_structure } = JSON.parse(permissions)?.company_shipper_settings;
  const { getValues } = useFormContext();

  return (
    <>
      {enable_new_address_structure && getValues(`schedule.${isPickupOrDelivery}_port_country`) && (
        <div>
          <label>
            {intl.formatMessage({
              id: "general.country",
              defaultMessage: "Country",
            })}
          </label>
          <div className="font-b4">
            <div>{getValues(`schedule.${isPickupOrDelivery}_port_country`)}</div>
          </div>
        </div>
      )}
    </>
  );
}
